SelectBox = App.loadClass 'core::SelectBox'

class exports.WeightSetsTab extends Handler

    init: () ->
        # don't call loadLayout() because the HTML is already loaded

        self = this
        sidebar = $(@layoutSelector)

        @subHandlers =
            'WeightSet':
                'class': 'portal::handlers/weightings/WeightSetDialog'
            'AddEditWeightSet':
                'class': 'portal::handlers/weightings/AddEditWeightSetDialog'
            'DeleteWeightSet':
                'class': 'portal::handlers/weightings/DeleteWeightSetDialog'
            'YieldRanges':
                'class': 'portal::handlers/weightings/YieldRangesDialog'
            'YieldRangesWithIrr':
                'class': 'portal::handlers/weightings/YieldRangesWithIrrDialog'

        @taffyObjects = @parent.taffyObjects


        # placement program dropdown
        sidebar.find('#sel_ws_pp').on 'change', () =>
            @destroyAllSubHandlers()
            @renderWeightSetSelect()

        sidebar.find('#sel_ws_pp').trigger 'change'


        # add button
        sidebar.find('#btn_add_ws').on 'click', () =>
            pp_id = sidebar.find('#sel_ws_pp').val()
            handler = @createSubHandler 'AddEditWeightSet'
            if handler
                handler.loadLayoutPostOptions = pp_id: pp_id
                handler.init()

        # info popover
        sidebar.find('#weight_set_popover').clickover
            html: true
            placement: 'right'
            container: '#bs2-container'

        # weight set dropdown
        sidebar.find('#sel_ws').on 'change', () ->
            id = parseInt $(this).val()
            if not id
                # hide the weight set specific content and destroy the Weight Set Handler
                sidebar.find('#toggle_weight_divs').hide()
                self.destroySubHandler('WeightSet', true)
                return

            # show the weight set specific content
            sidebar.find('#toggle_weight_divs').show()

            # set the appropriate sales zones for this weight set
            sel_zones = sidebar.find('select[name="sel_zones"]')
            sel_assoc = sidebar.find('select[name="sel_assoc"]')


            self.destroyAllSubHandlers()
            self.renderZoneSelects()

            sz_id = self.taffyObjects.sz( weight_sets_id: id ).select('id')
            sel_zones.val(sz_id)
            self.moveOptions(sel_zones, sel_assoc)

            # create the Weight Set Handler
            handler = self.createSubHandler 'WeightSet'
            if handler
                handler.loadLayoutPostOptions =
                    ws_id: id
                handler.init()


        # rename button
        sidebar.find('#btn_rename_ws').on 'click', () =>
            handler = @createSubHandler 'AddEditWeightSet'
            if handler
                handler.loadLayoutPostOptions =
                    pp_id: sidebar.find('#sel_ws_pp').val()
                    weight_set_id: sidebar.find('#sel_ws').val()
                handler.init()

        # delete button
        sidebar.find('#btn_delete_ws').on 'click', () =>
            handler = @createSubHandler 'DeleteWeightSet'
            if handler
                handler.loadLayoutPostOptions =
                    weight_set_id: sidebar.find('#sel_ws').val()
                handler.init()

        # zones buttons
        sidebar.find('#btn_assoc_zones').on 'click', () =>
            @assocZones()

        sidebar.find('#btn_deassoc_zones').on 'click', () =>
            @deassocZones()

        @renderWeightSetSelect()


    renderWeightSetSelect: (autoselect = null) ->
        sidebar = $(@layoutSelector)
        ppID = parseInt sidebar.find('#sel_ws_pp').val()

        ws = @taffyObjects.ws( placement_programs_id: ppID ).order('name').select('id', 'name')

        SelectBox.render(ws, sidebar.find('#sel_ws'))

        # select an item by id, else select nothing
        if autoselect
            sidebar.find('#sel_ws').val(autoselect).trigger('change')
        else
            sidebar.find('#sel_ws').val('').trigger('change')


    renderZoneSelects: () ->
        sidebar = $(@layoutSelector)
        ppID = parseInt sidebar.find('#sel_ws_pp').val()

        unassigned = @taffyObjects.sz( placement_programs_id: ppID, weight_sets_id: null ).order('name').select('id', 'name')
        SelectBox.render(unassigned, sidebar.find('select[name="sel_zones"]'), [])

        wsID = parseInt sidebar.find('#sel_ws').val()
        assigned = @taffyObjects.sz( weight_sets_id: wsID ).order('name').select('id', 'name')
        SelectBox.render(assigned, sidebar.find('select[name="sel_assoc"]'), [])


    assocZones: (doSave = true) ->
        return @_doAssoc false, doSave

    deassocZones: (doSave = true) ->
        return @_doAssoc true, doSave


    _doAssoc: (deassoc, doSave) ->
        sidebar = $(@layoutSelector)

        if deassoc
            fromSel = sidebar.find('select[name="sel_assoc"]')
            toSel   = sidebar.find('select[name="sel_zones"]')
            wsID = null
        else
            fromSel = sidebar.find('select[name="sel_zones"]')
            toSel   = sidebar.find('select[name="sel_assoc"]')
            wsID = parseInt sidebar.find('#sel_ws').val()

        # get the zones to move
        zones = fromSel.val()
        if not zones?
            return false

        # update taffy
        for zone in zones
            @taffyObjects.sz( id: parseInt zone ).update
                weight_sets_id: wsID

        # move DOM elements
        retVal = @moveOptions fromSel, toSel

        # save to DB
        @_saveSalesZones() if doSave

        return retVal


    moveOptions: (from, to) ->
        if not (from instanceof jQuery)
            from = $(from)

        if not (to instanceof jQuery)
            to = $(to)

        vals = from.val()
        if not vals
            return false

        for val in vals
            sel = 'option[value="' + val + '"]'
            from.find(sel).appendTo(to)
            from.find(sel).remove()
        to.find('option').sort(@_selectSort).appendTo(to)
        to.val('')

        return true


    _saveSalesZones: () ->
        zones = @taffyObjects.sz().get()

        zones_data = zones.map (zone) ->
            data =
                id: zone.id
                ws_id: zone.weight_sets_id ? null

        $.post 'backend/portal/weightings/save-sales-zones', { zones: zones_data }, (response) ->
            # TODO: we should maybe display a confirmation?
            undefined


    _selectSort: (a, b) ->
        return strnatcasecmp a.text, b.text


    destroy: () ->
        super false
